
import { createTheme, } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        type: 'light',
        primary:{
            main:'#D62027',
        },
        secondary:{
           main :'#8CE7FF',
        },
    },
    typography: {
        fontFamily: '"Nunito","Roboto", "Helvetica", "Arial", sans-serif',
        fontWeightMedium: 600
    },
})

